import { cardImageSources, type GenericCharacter } from './types'

export const genericGnomo: GenericCharacter = {
  id: 'generic-gnomo',
  enabled: true,
  order: 14,
  displayName: 'Milo',
  icon: '🍄',
  imageSources: cardImageSources('generic-gnomo'),
}
